import strings, { formatMessage } from '../strings';

const templateLabel = (templateKey) =>
  templateKey === 'modern'
    ? strings.coverLetter.templateModern
    : strings.coverLetter.templateClassic;

/**
 * Small self-contained letter thumbnail. NOT CoverLetterPreview — that is
 * branding-driven and the order document does not carry frozen branding, so it
 * would render an empty "Hi there, I'm —" letter on read surfaces.
 */
export const CoverLetterThumb = ({ templateKey, className = '' }) => (
  <div
    aria-hidden="true"
    data-testid="mod-cover-letter-thumb"
    className={`relative flex h-20 w-16 shrink-0 flex-col gap-1 rounded border border-neutral-200 bg-white p-1.5 ${className}`}
  >
    <div
      className={`h-2 w-2/3 rounded-sm ${
        templateKey === 'modern' ? 'bg-primary-400' : 'bg-[#8a4636]'
      }`}
    />
    <div className="mt-0.5 h-px w-full bg-neutral-200" />
    <div className="h-px w-full bg-neutral-200" />
    <div className="h-px w-4/5 bg-neutral-200" />
    <div className="h-px w-full bg-neutral-200" />
    <div className="mt-auto flex items-center gap-1">
      <span className="grid h-4 w-4 place-items-center rounded-full bg-primary-100 text-[9px] text-primary-700">
        ✉
      </span>
      <span className="h-px flex-1 bg-neutral-200" />
    </div>
  </div>
);

/** "Cover letter · Classic/Modern" chip. */
export const CoverLetterChip = ({ templateKey }) => (
  <span
    data-testid="mod-cover-letter-chip"
    className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-700"
  >
    <span aria-hidden="true">✉</span>
    {formatMessage(strings.coverLetter.includedChip, {
      template: templateLabel(templateKey),
    })}
  </span>
);

export default CoverLetterChip;
